import React, { FunctionComponent } from 'react';

import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import AppState from '@webapp/store/state';

import { Translate } from 'react-localize-redux';

import styled from 'styled-components';

import Flex from '@components/layout/flex';
import Typography from '@components/basics/typography';

import Counter from '@components/counter';
import AchievementItem, { AchievementItemType } from './achievement-item';

import { AllAchievementsComplete } from './achievements';
import { GetAchievements } from '@webapp/store/artist/action-creators';

interface AchievementsProps {
  className?: string;
  achievementsCompleted: number;
  isAllAchievementsCompleted: boolean;
  isFrontendCopy: boolean;
  achievements: AchievementItemType[];
  getAchievements: () => GetAchievements;
  openDistribution: () => void;
}

const mapStateToProps = (state: AppState) => {
  const completedAchievementsIds = state.artist.active?.achievements || [];
  let achievements: AchievementItemType[] = [];
  let achievementsCompleted = 0;
  let isAllAchievementsCompleted = true;
  let isFrontendCopy = false;

  if (state.artist.achievements) {
    isAllAchievementsCompleted = false;
    const newAchievements = [...state.artist.achievements].map(
      (val): AchievementItemType => {
        const newValue: AchievementItemType = { ...val, isCompleted: false };

        if (completedAchievementsIds.includes(val.id ?? '')) {
          newValue.isCompleted = true;
          achievementsCompleted += 1;
        }

        return newValue;
      }
    );

    if (
      state.artist.achievements?.length > 0 &&
      state.artist.achievements?.length === achievementsCompleted
    ) {
      isAllAchievementsCompleted = true;
      achievements = AllAchievementsComplete(true);
      isFrontendCopy = true;
    } else {
      achievements = newAchievements;
    }
  }

  return {
    isPlanFeature:
      state.subscription.current?.plan.toLocaleLowerCase() === 'beginner',
    achievementsCompleted,
    isAllAchievementsCompleted,
    achievements,
    isFrontendCopy,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getAchievements: () => dispatch(new GetAchievements()),
});

const Achievements: FunctionComponent<AchievementsProps> = ({
  className,
  achievementsCompleted,
  isAllAchievementsCompleted,
  achievements,
  getAchievements,
  isFrontendCopy,
  openDistribution,
}) => {
  React.useEffect(() => {
    getAchievements();
  }, [getAchievements]);

  if (!achievements?.length) return null;

  return (
    <div className={className || ''}>
      <AchievementsHeader justifyContent="space-between" alignItems="center">
        <div>
          <Title customFont="bold" type="big-title">
            <Translate id="DASHBOARD.NEW_DASHBOARD.ACHIEVEMENTS.TITLE" />
          </Title>
          <Subtitle>
            <Translate id="DASHBOARD.NEW_DASHBOARD.ACHIEVEMENTS.SUBTITLE" />
          </Subtitle>
        </div>
        {!isAllAchievementsCompleted && (
          <Counter current={achievementsCompleted} max={achievements.length} />
        )}
      </AchievementsHeader>
      {achievements.map((item, i) => (
        <AchievementItem
          key={i}
          icon={item.icon}
          title={item.title}
          subtitle={item.subtitle}
          to={item.to === '/' ? '/dashboard' : item.to}
          isCompleted={item.isCompleted}
          isFrontendCopy={isFrontendCopy}
          achievementKey={item.achievementKey}
          openDistribution={openDistribution}
        />
      ))}
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Achievements);

const AchievementsHeader = styled(Flex)`
  width: 100%;
  margin-bottom: 32px;
`;

const Title = styled(Typography)`
  margin-bottom: 8px;
`;

const Subtitle = styled(Typography)`
  line-height: 17px;
  color: ${({ theme }) => theme.colors.tertiary};
`;
